import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@monksflow/monks-ui';
import { MoreVerticalIcon, PencilIcon, Trash2Icon } from 'lucide-react';
import type { FocusGroupTableData } from '../../types';
import { useTranslation } from 'react-i18next';

interface FocusGroupRowActionsProps {
  focusGroup: FocusGroupTableData;
  onEdit: (focusGroup: FocusGroupTableData) => void;
  onDelete: (focusGroup: FocusGroupTableData) => void;
}

export function FocusGroupRowActions({ focusGroup, onEdit, onDelete }: FocusGroupRowActionsProps) {
  const { t } = useTranslation('audiences');

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="mini"
          aria-label={t('focusGroups.focusGroupRowActions.focusGroupActions')}
          className="size-9 p-0"
          onClick={(e) => e.stopPropagation()}
        >
          <MoreVerticalIcon className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onClick={(e) => e.stopPropagation()}>
        <DropdownMenuItem onSelect={() => onEdit(focusGroup)}>
          <PencilIcon className="mr-2 size-4 text-foreground" />
          {t('focusGroups.focusGroupRowActions.edit')}
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => onDelete(focusGroup)}>
          <Trash2Icon className="mr-2 size-4 text-foreground" />
          {t('focusGroups.focusGroupRowActions.delete')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
